module.exports = __webpack_public_path__ + "img/yijian_zhongji.1499a3d3.png";